module.exports = __webpack_public_path__ + "img/invalid-already.3c1fe9dc.png";